import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'RelationalDiagram',
  label: 'Network Diagram Relational Chart',
  icon: 'DocumentTextIcon',
  description: 'Displays a network diagram from supplied data',
  properties: [
    {
      label: 'Local Store Data Key or Path',
      name: 'localStoreKeyName',
      default: 'relationalData',
      description:
        'This component requires the a data object to be present in the local store containing the network data of { groups, links, nodes }. Provide the local storey key name or path where this data can be found.',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
